<template>
  <div class="grid">
    <div v-for="(item, key) in items" :key="key" class="dea-live-wrapper xs-12 s-6 l-4">
      <CardDeaLive :item="item" @save-bookmark="saveBookmark" @delete-bookmark="deleteBookmark" />
    </div>
  </div>
</template>

<script>
import CardDeaLive from "@/components/patterns/CardDeaLive";
import bookmarksSetup from "@/components/mixins/bookmarksSetup";

export default {
  name: "DeALiveList",
  components: { CardDeaLive },
  mixins: [bookmarksSetup],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      bookmarksSave: "saveDeaLive",
      bookmarksGet: "getDeaLive",
      bookmarkType: "post",
    };
  },
};
</script>
<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.dea-live-wrapper {
  margin-bottom: $space-small;
}
</style>
